import { useState } from "react";

const ImageWithLoader = ({ src, alt, className = "", style = {}, wrapperStyle = {} }) => {
  const [loaded, setLoaded] = useState(false);

  if (!src) return null;

  return (
    <span
      className="image-loader-wrap"
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...wrapperStyle,
      }}
    >
      {!loaded && <span className="image-loader-circle" />}
      <img
        src={src}
        alt={alt}
        className={className}
        style={{
          ...style,
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.2s ease",
        }}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
      />
    </span>
  );
};

export default ImageWithLoader;
